import React from 'react';
import styled, { css } from 'styled-components';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';
import { getCurrentPanelHelpLink } from '@panel/commons/helpers/creditsHelper';
import { useSelector } from 'react-redux';
import { selectColor } from '@panel/commons/core';
import { sendTrackingInfo } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { select } from '@panel/commons/core/themev2';
import chevronDetail from '../../../assets/icons/ChevronDown.svg';

function ProductsTable({ globalCredits, branchCredits, isDesktop, isMobile, hasCreditFromUnifiedPanel, hasError }) {
  const { t } = useTranslation();
  const headers = [
    `Tipo de ${t('panel.available.products.plan')}`,
    'panel.available.products.plan',
    'panel.available.products.availables',
    'panel.available.products.active'
  ];
  const { userTypeId, publisherTypeId } = useSelector(userInfoSelectors.getuserInfoState);
  const adminTypes = ['1', '2'];
  const isParticular = publisherTypeId === '1';
  const onlyGlobalProducts = adminTypes.includes(userTypeId) && !isParticular;
  const withBranch = branchCredits && (!onlyGlobalProducts || !globalCredits);

  return (
    <TableContainer isDesktop={isDesktop} isMobile={isMobile}>
      <h2 data-panel='panel-products.title'>{t('panel.available.products.title')}</h2>
      <TableHeader isDesktop={isDesktop}>
        {headers.map((item, i) => {
          return (
            <div className={`header-text ${i > 1 && 'align-self'}`} key={item} data-panel={item}>
              {t(item)}
            </div>
          );
        })}
      </TableHeader>
      {globalCredits && !hasError && (
        <TableRowMain>
          <div className='row-items'>
            {globalCredits.map((item, i) => {
              return (
                <div
                  key={`${item.name + i}`}
                  className={`row-sub-table ${item.availableItemsLabel === '0' && ' withoutCredits'}`}
                  data-panel={`row-sub-table-gCredits-${i}`}
                >
                  <div className='row-sub-table-item' data-panel={`publicationType-gCredits-${i}`}>
                    {t(`panel.avisos.planName.${item.publicationType}`)}
                  </div>
                  <div className='row-sub-table-item' data-panel={`planName-gCredits-${i}`}>
                    {item.name}
                  </div>
                  <div className='row-sub-table-item number-item' data-panel={`availableItems-gCredits-${i}`}>
                    {item.availableItemsLabel}
                  </div>
                  <div className='row-sub-table-item number-item' data-panel={`consumedItems-gCredits-${i}`}>
                    {item.consumedItems}
                  </div>
                </div>
              );
            })}
          </div>
        </TableRowMain>
      )}
      {hasError && (
        <ErrorLoadingCredits isMobile={isMobile}>{t(`panel.avisos.planName.ErrorLoadingCredits`)}</ErrorLoadingCredits>
      )}
      {withBranch &&
        !hasError &&
        branchCredits.map(branch => {
          return (
            <TableRow key={branch.branchId}>
              <div className='row-items'>
                {branch.creditItems &&
                  branch.creditItems.map((item, index) => {
                    return (
                      <div
                        key={`${item.name + index}`}
                        className={`row-sub-table ${item.availableItemsLabel === '0' && ' withoutCredits'}`}
                        data-panel={`row-sub-table-${index}`}
                      >
                        <div className='row-sub-table-item' data-panel={`publicationType-${index}`}>
                          {t(`panel.avisos.planName.${item.publicationType}`)}
                        </div>
                        <div className='row-sub-table-item' data-panel={`planName-${index}`}>
                          {item.name}
                        </div>
                        <div className='row-sub-table-item number-item' data-panel={`availableItems-${index}`}>
                          {item.availableItemsLabel}
                        </div>
                        <div className='row-sub-table-item number-item' data-panel={`consumedItems-${index}`}>
                          {item.consumedItems}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </TableRow>
          );
        })}
      {!hasError && (
        <div className='lower-bottoms'>
          {hasCreditFromUnifiedPanel && (
            <CustomLink href={getCurrentPanelHelpLink()} target='_blank' isMobile={isMobile}>
              {t('panel.posting.productos.morePlansInfo_UnifiedPanels')}
            </CustomLink>
          )}
          {hasCreditFromUnifiedPanel && onlyGlobalProducts && globalCredits && !isMobile && (
            <div className='separator' />
          )}
          {onlyGlobalProducts && globalCredits && (
            <CustomLink
              href='../configuracion/administrarTopesSucursales.bum'
              target='_blank'
              onClick={() => sendTrackingInfo('Panel', 'Mis avisos', 'Productos disponibles-Ver detalle por sucursal')}
              isMobile={isMobile}
            >
              {t('panel.posting.productos.verDetalle')}
              <img src={chevronDetail} alt='Ver detalle' height={22} />
            </CustomLink>
          )}
        </div>
      )}
    </TableContainer>
  );
}

const TableRow = styled.div`
  display: flex;
  padding-top: 16px;
  font-size: 12px;
  border-top: 0.8px solid ${selectColor('grayMediumLight')};
  .row-name {
    width: 25%;
    white-space: break-spaces;
    padding-left: 16px;
    font-weight: 500;
  }
  .row-items {
    width: 100%;
    .row-sub-table {
      display: flex;
      margin-bottom: 16px;
      .row-sub-table-item {
        width: 33%;
        white-space: break-spaces;
        padding-left: 16px;
        align-self: center;
      }
      .number-item {
        text-align: center;
      }
    }
    .withoutCredits {
      color: ${select('feedbackWrong')};
    }
  }
`;

const CustomLink = styled.a`
  color: black;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: ${({ isMobile }) => (isMobile ? '0px' : '20px')};
  margin-bottom: 20px;
  > img {
    margin-left: 8px;
    transform: rotate(-90deg);
  }
`;

const TableRowMain = styled(TableRow)`
  .row-name {
    font-weight: 600;
    font-size: 14px;
  }
  .row-items {
    font-weight: 500;
  }
`;

const desktopContainer = css`
  margin: 0;
  border: 1px solid ${selectColor('grayMediumLight')};
  border-top: none;
  border-radius: 0px 0px 8px 8px;
`;

const TableContainer = styled.div`
  margin-top: 68px;
  display: flex;
  flex-direction: column;
  ${({ isDesktop }) => isDesktop && desktopContainer}
  h2 {
    margin: 0 0 12px 16px;
    ${({ isDesktop }) =>
      isDesktop &&
      css`
        display: none;
      `}
  }
  .lower-bottoms {
    display: flex;
    justify-content: flex-end;
    flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
    align-items: center;
    margin-top: ${({ isMobile }) => (isMobile ? '20px' : '0px')};
    .separator {
      margin-bottom: 17px;
    }
    .separator:after {
      content: '-';
      font-weight: 600;
      line-height: 130%;
      margin-right: 20px;
      vertical-align: middle;
    }
  }
`;

const desktopTableHeader = css`
  color: ${selectColor('grayDark')};
  background-color: white;
  height: 54px;
`;

const TableHeader = styled.div`
  background-color: ${selectColor('grayLight')};
  color: ${selectColor('grayDarkLight')};
  font-size: 14px;
  font-weight: 500;
  display: flex;
  height: 42px;
  .header-text {
    display: flex;
    align-items: center;
    flex: 1;
    padding-left: 16px;
    white-space: normal;
  }
  .align-self {
    display: flex;
    justify-content: center;
  }
  ${({ isDesktop }) => isDesktop && desktopTableHeader}
`;

const ErrorLoadingCredits = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${selectColor('darkRed')};
  height: 164px;
  padding-top: 18px;
  border-top: 1px solid ${selectColor('grayMediumLight')};
  border-radius: 0px 0px 6px 6px;
  padding: auto;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  ${({ isMobile }) =>
    isMobile &&
    css`
      white-space: break-spaces;
      text-align: center;
      padding: 24px;
    `}
`;

export default ProductsTable;
